import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { SETTINGS_TYPES } from "@/constant";
import CheckboxEmpty from "./CheckboxEmpty";
import s from './CheckboxSettings.module.css';
import classNames from "classnames";
import { Tooltip } from "antd";

const CheckBoxSettings = ({
    name,
    label,
    changeSetting,
    marker,
    className = '',
    disabled = false,
    defaultValue = '0',
    //condition,
    ...props
}) => {
    const storeValue = useSelector(store => store.settings[name]);
    const resolvedValue = storeValue ?? defaultValue;
    const [checkboxValue, setCheckboxValue] = useState(resolvedValue);
    useEffect(() => {
        setCheckboxValue(resolvedValue);
    }, [marker, resolvedValue]);

    const condition = props.condition;
    const conditionStore = useSelector(store => store.settings[condition]);
    const isShow = condition ? (conditionStore == 1) : true;
    return (<>
    {
        isShow ?
        <CustomCheckboxSettings
            label={label}
            onClick={() => {
                const isTrue = checkboxValue == '1';
                setCheckboxValue(isTrue ? '0' : '1');
                changeSetting({
                    key: name,
                    value: isTrue ? '0' : '1',
                    type: SETTINGS_TYPES.GENERAL
                })
            }}
            value={Number(checkboxValue)}
            className={className}
            disabled={disabled}
            { ...props }
        /> :
        <></>
    }</>);
}

export default CheckBoxSettings;

export const CustomCheckboxSettings = ({
    onClick,
    className = '',
    value,
    label,
    tooltip = '',
    disabled = false,
    ...props
}) => {
    return (<div
        className={classNames(s.checkboxWraper, className)}
        onClick={disabled ? () => {} : onClick}
        { ...props }
    >
        <CheckboxEmpty
            value={value}
            disabled={disabled}
        />
        <Tooltip title={tooltip}>
            <div className={s.checkboxSettingsText}>{ label }</div>
        </Tooltip>
    </div>);
}
